import { render } from "./Iso15022Page.vue?vue&type=template&id=650bef58"
import script from "./Iso15022Page.vue?vue&type=script&lang=js"
export * from "./Iso15022Page.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__